import React from 'react';

export function Pill({ label, swatch, isHidden, onClick, value }) {
    return (
        <button onClick={onClick} className={`chart-pill${isHidden ? ' chart-pill--hidden' : ''}`}>
            <span className="chart-pill__swatch" style={{ background: swatch }} />
            {label}
            {value != null && <span className="chart-pill__value"> · {value}</span>}
        </button>
    );
}
